module.exports = __webpack_public_path__ + "img/the-mad-scientist.af23d5de.svg";